import { format } from "@formkit/tempo"
import clientHttp from '../tools/clientHttp'
import generateXls from '../tools/generatetXls'
import filterByPermissions from '../tools/filterByPermissions'

const URL = "/requests";
const URL_MASSIVE = "/requests/massive-request-item";
const URL_DELIVERY = "/requests/delivery";
let requestsItems = [];
let langDate = "es";
let requests = [];

export const saveRequest = async (request) => {
    return clientHttp.post(`${URL}`, request)
}

export const updateRequestItem = async (request) => {
    return clientHttp.put(`${URL_MASSIVE}`, request)
}

export const updateRequest = async (request) => {
    return clientHttp.patch(`${URL}/${request.id}`, request)
}

export const changeRequestItem = async (requestItemId, changeRequestItemDto) => {
    return clientHttp.patch(`${URL}/change-item/${requestItemId}`, changeRequestItemDto)
}

export const getRequests = async () => {
    let allRequests = (await clientHttp.get(`${URL}`)).data.map(request => ({
        ...request,
        requestDate: format(request.requestDate, "DD-MM-YYYY", langDate),
        costCenter: request.items?.[0]?.employee?.costCenter || "-",
    }));

    return filterByPermissions(allRequests || []);
}

export const getRequestById = async (id) => {
    return clientHttp.get(`${URL}/${id}`)
}

export const getRequestByStatus = async (statuses, requests = false) => {
    console.log("getRequestByStatus", statuses);
    const allRequests = requests ? requests : await getRequests();
    const statusArray = Array.isArray(statuses) ? statuses : [statuses];
    return allRequests.sort((a, b) => b.id - a.id).filter(request =>
        statusArray.some(status =>
            request.status.toLowerCase() === status.toLowerCase()
        )
    );
}

export const getRequestByStatusAndQuoteRequest = async () => {
    const allRequests = await getRequestByStatus(['AUTORIZADO']);
    return allRequests.filter(request =>
        !request.purchaseOrder
    );
}

export const getRequestByStatusAndPurchaseOrder = async () => {
    const allRequests = await getRequestByStatus(['AUTORIZADO', 'RECIBIDO']);
    return allRequests.filter(request =>
        request.purchaseOrder
    );
}

export const cruceProducts = async (request) => {
    return clientHttp.post(`${URL}/cruce-products`, request)
}

export const saveDelivery = async (delivery) => {
    return clientHttp.post(`${URL_DELIVERY}`, delivery)
}

export const getDeliveryByRequest = async (requestId) => {
    return (await clientHttp.get(`${URL_DELIVERY}/${requestId}`)).data
}

export const getDeliveriesByDates = async (dateInit, dateEnd) => {
    return (await clientHttp.get(`${URL_DELIVERY}/search-date?dateInit=${dateInit}&dateEnd=${dateEnd}`)).data
}

export const xlsRequestStatus = async (status) => {
    const requestFull = (await clientHttp.get(`${URL}/status/${status}`)).data;
    generateExcel(requestFull);
}

const generateExcel = (data) => {
    const process = []
    data.forEach(req => {
        req?.items.forEach(item => {
            const reqLin = {
                ref: req.ref,
                estado: req.status,
                fecha: req.requestDate,
                solicitante: req.user.fullName,
                detalles: item.observation,
                productCode: item.product?.name,
                productName: item.product?.description,
                productSize: item.product?.size,
                productCategory: item.category?.name,
                quantity: item.quantity,
                productPrice: item.product?.price,
                total: item.quantity * (item.product?.price || 0),
                employeeRut: item.employee?.rut,
                employeeName: item.employee?.firstName,
                employeeFatherName: item.employee?.fatherName,
                employeeMotherName: item.employee?.motherName,
                employeeGender: item.employee?.gender,
                employeeCostCenter: item.employee?.costCenter,
                employeePosition: item.employee?.position,
                employeeSizePants: item.employee?.sizePants,
                employeeSizeMescal: item.employee?.sizeMescal,
                employeeSizeUniform: item.employee?.sizeUniform
            }
            process.push(reqLin)
        })
    })
    generateXls(process, "solicitudes");
}